import React from 'react';
import {useEnvironment, WidgetProps} from '@wix/yoshi-flow-editor';
import {PaymentRequestControllerProps} from '../../../types/paymentRequestApp.types';

type VoidReturn<T> = T extends (...args: infer P) => unknown ? (...args: P) => void : T;
type VoidMethodsDeep<T extends Record<string, unknown>> = {
  [K in keyof T]: T[K] extends Record<string, unknown> ? VoidMethodsDeep<T[K]> : VoidReturn<T[K]>;
};
export type UseControllerPropsResult = WidgetProps<VoidMethodsDeep<PaymentRequestControllerProps>>;

const Context = React.createContext({} as WidgetProps<PaymentRequestControllerProps>);

export function useControllerProps(): UseControllerPropsResult {
  return React.useContext(Context);
}

export function ControllerContext({
  value,
  children,
}: {
  value: WidgetProps<PaymentRequestControllerProps>;
  children: React.ReactNode;
}) {
  const {isMobile} = useEnvironment();

  return <Context.Provider value={{...value, isOneColumnView: isMobile}}>{children}</Context.Provider>;
}
